import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Banner from "../components/Banner";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import Config from "../Config";
import "../styles/services.scss";

const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/main_banner.jpg";

const Features = (props) => {
    return (
        <MDBox className="services-page" bgColor="white">
            <Banner
                image={bgImage}
                content={
                    (
                        <Container className="text-container">
                            <h1>Our Features</h1>
                        </Container>
                    )
                }
            />
            <MDBox className="services-container">
                <Container>
                    <Grid container className="services-content">
                        <Grid item xs={12} md={3} lg={3} className="service-icon">
                            <span style={{backgroundColor: "#5a92fa"}}>
                                <svg viewBox="19.868 38.586 160.264 121.194" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M149.73 83.547c-2.538-25.284-24.211-44.961-49.73-44.961S52.808 58.263 50.269 83.547c-17.67 3.837-30.401 19.54-30.401 37.674 0 21.261 17.297 38.559 38.559 38.559h83.146c21.261 0 38.559-17.297 38.559-38.559 0-18.135-12.732-33.838-30.402-37.674zm-8.157 64.423H58.427a26.755 26.755 0 0 1-16.198-5.482l21.237-21.114 13.181 13.19 36.505-35.875 8.081 8.047 6.076-30.357-30.353 6.177 8.281 8.243-28.512 28.025-13.236-13.239-28.56 28.399a26.646 26.646 0 0 1-3.252-12.763c0-13.887 10.85-25.598 24.701-26.661l5.452-.419v-5.488l-.003-.16C61.868 67.486 78.992 50.395 100 50.395c21.047 0 38.171 17.078 38.172 38.069l-.004 5.677 5.453.419c13.851 1.063 24.701 12.774 24.701 26.661 0 14.749-11.999 26.749-26.749 26.749z" fill="#1b1c1e"></path>
                                    </g>
                                </svg>
                            </span>
                        </Grid>
                        <Grid item xs={12} md={9} lg={9} className="service-content">
                            <div>
                                <h3>Olympus-Grid: Essentials</h3>
                                <ul>
                                    <li>Learn about the Olympus-Grid development model</li>
                                    <li>Follow our docs (with link to docs) to build and deploy your own plugins</li>
                                    <li>Link to listing</li>
                                </ul>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3} className="service-icon">
                            <span style={{backgroundColor: "#fd6262"}}>
                                <svg viewBox="20.532 45.947 158.928 108.107" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M82.935 75.852l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.828 4.828 0 0 0 0-8.768l-44.836-20.692a4.826 4.826 0 0 0-4.047 0L82.935 67.083a4.828 4.828 0 0 0 0 8.769zm46.86-19.759l33.312 15.374-33.312 15.374-33.312-15.374 33.312-15.374z" fill="#1B1C1E"></path>
                                        <path d="M172.608 95.616l-42.813 19.758-42.813-19.758a4.83 4.83 0 0 0-4.047 8.769l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.83 4.83 0 0 0-4.047-8.769z" fill="#1B1C1E"></path>
                                        <path d="M172.608 124.149l-42.813 19.758-42.813-19.758a4.828 4.828 0 1 0-4.047 8.769l44.836 20.692a4.833 4.833 0 0 0 4.048 0l44.836-20.692a4.83 4.83 0 0 0-4.047-8.769z" fill="#1B1C1E"></path>
                                        <path d="M65.095 95.171H25.368a4.829 4.829 0 1 0 0 9.658h39.727a4.829 4.829 0 1 0 0-9.658z" fill="#1B1C1E"></path>
                                        <path d="M65.095 76.446H37.44a4.829 4.829 0 1 0 0 9.658h27.655a4.829 4.829 0 1 0 0-9.658z" fill="#1B1C1E"></path>
                                        <path d="M65.095 113.897H49.512a4.829 4.829 0 1 0 0 9.658h15.583a4.829 4.829 0 1 0 0-9.658z" fill="#1B1C1E"></path>
                                    </g>
                                </svg>
                            </span>
                        </Grid>
                        <Grid item xs={12} md={9} lg={9} className="service-content">
                            <div>
                                <h3>Olympus-Grid: Starter</h3>
                                <ul>
                                    <li>Easily Install, Deploy and Host ReactJS Sites natively on Salesforce.com</li>
                                    <li>Easily grow, enhance, and evolve your enterprise architecture using our Strategic Advisor, powered by Agentforce</li>
                                    <li>Link to listing</li>
                                </ul>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={3} lg={3} className="service-icon">
                            <span style={{backgroundColor: "#889ce7"}}>
                                <svg viewBox="20.42 48.257 159.16 103.485" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="M177.118 96.151L142.48 80.165a4.235 4.235 0 0 0-3.555 0l-34.637 15.986a4.252 4.252 0 0 0-2.464 3.849c0 1.648.967 3.159 2.463 3.85l34.638 15.986c.553.255 1.167.39 1.777.39.619 0 1.217-.131 1.778-.39l34.638-15.986c1.496-.691 2.462-2.202 2.462-3.85s-.967-3.159-2.462-3.849zM165.223 100l-24.521 11.316L116.181 100l24.52-11.316L165.223 100z" fill="#1b1c1e"></path>
                                        <path d="M98.177 100a4.251 4.251 0 0 0-2.463-3.849L61.076 80.165a4.236 4.236 0 0 0-3.554 0L22.883 96.151c-1.496.691-2.463 2.202-2.463 3.849s.967 3.159 2.463 3.85l34.638 15.985a4.257 4.257 0 0 0 1.777.391c.619 0 1.216-.131 1.777-.39l34.638-15.986a4.253 4.253 0 0 0 2.464-3.85zm-14.358 0l-24.521 11.316L34.778 100l24.52-11.316L83.819 100z" fill="#1b1c1e"></path>
                                        <path d="M63.585 72.333l34.638 15.985a4.257 4.257 0 0 0 1.777.391 4.21 4.21 0 0 0 1.777-.39l34.639-15.986a4.253 4.253 0 0 0 2.462-3.85 4.252 4.252 0 0 0-2.462-3.849l-34.639-15.986a4.236 4.236 0 0 0-3.554 0L63.585 64.634a4.253 4.253 0 0 0-2.463 3.849c0 1.648.966 3.159 2.463 3.85zm11.895-3.85L100 57.167l24.52 11.316L100 79.8 75.48 68.483z" fill="#1b1c1e"></path>
                                        <path d="M136.417 127.667l-34.639-15.986a4.236 4.236 0 0 0-3.554 0l-34.639 15.986c-1.496.691-2.463 2.202-2.463 3.849s.967 3.159 2.463 3.85l34.638 15.985a4.257 4.257 0 0 0 1.777.391 4.21 4.21 0 0 0 1.777-.39l34.639-15.986c1.496-.691 2.462-2.202 2.462-3.85s-.966-3.158-2.461-3.849zm-11.897 3.85L100 142.833l-24.52-11.316L100 120.2l24.52 11.317z" fill="#1b1c1e"></path>
                                    </g>
                                </svg>
                            </span>
                        </Grid>
                        <Grid item xs={12} md={9} lg={9} className="service-content">
                            <div>
                                <h3>Olympus-Grid: Enterprise</h3>
                                <ul>
                                    <li>Olympus-Grid: Starter plus:</li>
                                    <li>Build Next Generation, AI powered systems within a single managed package</li>
                                    <li>Quickly deploy custom, pixel perfect, mobile ready web sites in seconds</li>
                                    <li>Host fully scalable and secure API endpoints</li>
                                    <li>Manage Async Worklows without headache</li>
                                    <li>Host Data on Salesforce or other Cloud Data Providers</li>
                                    <li>Leverage Digital Communities or Build From Scratch</li>
                                    <li>Significantly decrease support and DevOps requirements</li>
                                    <li>Dramatically increase development velocity</li>
                                    <li>Dramatically lower time-to-value</li>
                                    <li>Link to listing</li>
                                </ul>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
        </MDBox>
    )
}

export default Features;